export const dateKey = (date = new Date()) => new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Copenhagen", year: "numeric", month: "2-digit", day: "2-digit" }).format(date);

export const addDays = (key, days) => {
    const date = new Date(`${key}T12:00:00Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return dateKey(date);
};

export const jobDateKey = (job) => {
    const raw = String(job.date || job.deadline || "").trim().toLowerCase();
    if (raw === "i dag" || raw === "idag") return dateKey();
    if (raw === "i morgen" || raw === "imorgen") return addDays(dateKey(), 1);
    if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
    const match = /^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/.exec(raw);
    return match ? `${match[3]}-${match[2].padStart(2, "0")}-${match[1].padStart(2, "0")}` : null;
};